import { FC } from 'react';

import { IconProps } from './types';

export const BoxIcon: FC<IconProps> = ({
	className,
	color = '#06519E',
	size,
	height = 26,
	width = 22,
}) => (
	<svg
		className={className}
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 22 26"
	>
		<path
			fill={color}
			d="M11.0138 24.1432a3.2649 3.2649 0 0 0 1.5298-.4331l7.6433-4.3678a3.2843 3.2843 0 0 0 1.6356-2.8315V7.7796a3.2843 3.2843 0 0 0-1.641-2.8336L12.5478.5837A3.2777 3.2777 0 0 0 9.279.5815L5.794 2.5728a1.0878 1.0878 0 0 0-.61.3492L1.6367 4.947A3.2821 3.2821 0 0 0 0 7.7797v8.7301a3.2865 3.2865 0 0 0 1.641 2.8348l7.6346 4.3623a3.2655 3.2655 0 0 0 1.532.4342c.069.0066.1383.0066.2073 0l-.001.0022ZM9.8201 21.506v-8.729L2.1822 8.3918v8.118c0 .3862.2095.7495.5456.9437l7.0923 4.0525Zm2.1823 0 7.0966-4.0557c.3317-.192.5401-.5543.5412-.9417V8.3918l-7.6378 4.3852v8.729ZM6.0557 4.9362 3.2941 6.5139l7.6171 4.3733L13.65 9.3159 6.0557 4.9362Zm5.4055-2.4605 7.0672 4.0382-2.6896 1.545-7.5899-4.3764 2.1168-1.21a1.0966 1.0966 0 0 1 1.0955.0032Z"
			fillRule="evenodd"
		/>
	</svg>
);
